{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "קמפיינים של צ'אט חי",
      "NEW_CAMPAIGN": "צור קמפיין",
      "CARD": {
        "STATUS": {
          "ENABLED": "מופעל",
          "DISABLED": "כבוי"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "נשלח על ידי",
          "BOT": "בוט",
          "FROM": "מ",
          "URL": "כתובת URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "אין קמפיינים של צ'אט חי זמינים",
        "SUBTITLE": "צור קשר עם הלקוחות שלך באמצעות הודעות יזומות. לחץ על 'צור קמפיין' כדי להתחיל."
      },
      "CREATE": {
        "TITLE": "צור קמפיין צ'אט חי",
        "CANCEL_BUTTON_TEXT": "ביטול",
        "CREATE_BUTTON_TEXT": "צור",
        "FORM": {
          "TITLE": {
            "LABEL": "כותרת",
            "PLACEHOLDER": "אנא הכנס כותרת לקמפיין",
            "ERROR": "כותרת שדה חובה"
          },
          "MESSAGE": {
            "LABEL": "הודעה",
            "PLACEHOLDER": "אנא הכנס הודעה לקמפיין",
            "ERROR": "הודעה שדה חובה"
          },
          "INBOX": {
            "LABEL": "בחר תיבת דואר",
            "PLACEHOLDER": "בחר תיבת דואר",
            "ERROR": "נדרשת תיבת דואר נכנס"
          },
          "SENT_BY": {
            "LABEL": "נשלח על ידי",
            "PLACEHOLDER": "אנא בחר שולח",
            "ERROR": "שולח שדה חובה"
          },
          "END_POINT": {
            "LABEL": "כתובת URL",
            "PLACEHOLDER": "אנא הכנס כתובת URL",
            "ERROR": "אנא הכנס כתובת URL חוקית"
          },
          "TIME_ON_PAGE": {
            "LABEL": "זמן על הדף (שניות)",
            "PLACEHOLDER": "אנא הכנס זמן",
            "ERROR": "זמן על הדף שדה חובה"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "העדפות אחרות",
            "ENABLED": "הפעל קמפיין",
            "TRIGGER_ONLY_BUSINESS_HOURS": "הפעל רק בשעות העבודה"
          },
          "BUTTONS": {
            "CREATE": "צור",
            "CANCEL": "ביטול"
          },
          "API": {
            "SUCCESS_MESSAGE": "קמפיין צ'אט חי נוצר בהצלחה",
            "ERROR_MESSAGE": "היתה שגיאה. בקשה נסה שוב."
          }
        }
      },
      "EDIT": {
        "TITLE": "ערוך קמפיין צ'אט חי",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "קמפיין צ'אט חי עודכן בהצלחה",
            "ERROR_MESSAGE": "היתה שגיאה. בקשה נסה שוב."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "קמפיינים של SMS",
      "NEW_CAMPAIGN": "צור קמפיין",
      "EMPTY_STATE": {
        "TITLE": "אין קמפיינים של SMS זמינים",
        "SUBTITLE": "השק קמפיין SMS כדי להגיע ללקוחות שלך ישירות. שלח הצעות או פרסם הודעות בקלות. לחץ על 'צור קמפיין' כדי להתחיל."
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "מעבד",
          "COMPLETED": "הושלם",
          "SCHEDULED": "מתוזמן"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "נשלח מ-",
          "ON": "ב-"
        }
      },
      "CREATE": {
        "TITLE": "צור קמפיין SMS",
        "CANCEL_BUTTON_TEXT": "ביטול",
        "CREATE_BUTTON_TEXT": "צור",
        "FORM": {
          "TITLE": {
            "LABEL": "כותרת",
            "PLACEHOLDER": "אנא הכנס כותרת לקמפיין",
            "ERROR": "כותרת שדה חובה"
          },
          "MESSAGE": {
            "LABEL": "הודעה",
            "PLACEHOLDER": "אנא הכנס הודעה לקמפיין",
            "ERROR": "הודעה שדה חובה"
          },
          "INBOX": {
            "LABEL": "בחר תיבת דואר",
            "PLACEHOLDER": "בחר תיבת דואר",
            "ERROR": "נדרשת תיבת דואר נכנס"
          },
          "AUDIENCE": {
            "LABEL": "קהל",
            "PLACEHOLDER": "בחר את תוויות הלקוחות",
            "ERROR": "נדרש קהל"
          },
          "SCHEDULED_AT": {
            "LABEL": "זמן מתוכנן",
            "PLACEHOLDER": "אנא בחר את הזמן",
            "ERROR": "נדרש זמן מתוכנן"
          },
          "BUTTONS": {
            "CREATE": "צור",
            "CANCEL": "ביטול"
          },
          "API": {
            "SUCCESS_MESSAGE": "קמפיין SMS נוצר בהצלחה",
            "ERROR_MESSAGE": "היתה שגיאה. בקשה נסה שוב."
          }
        }
      }
    },
    "WHATSAPP": {
      "HEADER_TITLE": "קמפיינים של WhatsApp",
      "NEW_CAMPAIGN": "צור קמפיין",
      "EMPTY_STATE": {
        "TITLE": "אין קמפיינים של WhatsApp זמינים",
        "SUBTITLE": "השק קמפיין WhatsApp כדי להגיע ללקוחות שלך ישירות. שלח הצעות או פרסם הודעות בקלות. לחץ על 'צור קמפיין' כדי להתחיל."
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "מעבד",
          "COMPLETED": "הושלם",
          "SCHEDULED": "מתוזמן"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "נשלח מ-",
          "ON": "ב-"
        }
      },
      "CREATE": {
        "TITLE": "צור קמפיין WhatsApp",
        "CANCEL_BUTTON_TEXT": "ביטול",
        "CREATE_BUTTON_TEXT": "צור",
        "FORM": {
          "TITLE": {
            "LABEL": "כותרת",
            "PLACEHOLDER": "אנא הכנס כותרת לקמפיין",
            "ERROR": "כותרת שדה חובה"
          },
          "INBOX": {
            "LABEL": "בחר תיבת דואר",
            "PLACEHOLDER": "בחר תיבת דואר",
            "ERROR": "נדרשת תיבת דואר נכנס"
          },
          "TEMPLATE": {
            "LABEL": "תבנית WhatsApp",
            "PLACEHOLDER": "בחר תבנית",
            "INFO": "בחר תבנית לשימוש בקמפיין זה.",
            "ERROR": "תבנית נדרשת",
            "PREVIEW_TITLE": "עיבוד {templateName}",
            "LANGUAGE": "שפה",
            "CATEGORY": "קטגוריה",
            "VARIABLES_LABEL": "משתנים",
            "VARIABLE_PLACEHOLDER": "הזן ערך עבור {variable}"
          },
          "AUDIENCE": {
            "LABEL": "קהל",
            "PLACEHOLDER": "בחר את תוויות הלקוחות",
            "ERROR": "נדרש קהל"
          },
          "SCHEDULED_AT": {
            "LABEL": "זמן מתוכנן",
            "PLACEHOLDER": "אנא בחר את הזמן",
            "ERROR": "נדרש זמן מתוכנן"
          },
          "BUTTONS": {
            "CREATE": "צור",
            "CANCEL": "ביטול"
          },
          "API": {
            "SUCCESS_MESSAGE": "קמפיין WhatsApp נוצר בהצלחה",
            "ERROR_MESSAGE": "היתה שגיאה. בקשה נסה שוב."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "האם אתה בטוח שברצונך למחוק?",
      "DESCRIPTION": "פעולת המחיקה היא קבועה ולא ניתנת לביטול.",
      "CONFIRM": "מחק",
      "API": {
        "SUCCESS_MESSAGE": "מסע הפרסום נמחק בהצלחה",
        "ERROR_MESSAGE": "היתה שגיאה. בקשה נסה שוב."
      }
    }
  }
}
